export const DefaultShareableOptions = [
	{
		label: 'group',
		value: 'group'
	},
	{
		label: 'organization',
		value: 'organization'
	},
	// {
	// 	label: 'public',
	// 	value: 'public'
	// }
	{
		label: 'branch',
		value: 'branch'
	}
];

export const DefaultCategoryOptions = [
	{
		label: 'TOEIC',
		value: 'toeic'
	},
	{
		label: 'Business',
		value: 'business'
	},
	{
		label: 'Culture',
		value: 'culture'
	},
	{
		label: 'Entertainment',
		value: 'entertainment'
	},
	{
		label: 'IELTS',
		value: 'exams'
	},
	{
		label: 'Food',
		value: 'food'
	},
	{
		label: 'Other',
		value: 'other'
	},
	{
		label: 'Relationships',
		value: 'relationships'
	},
	{
		label: 'Travel',
		value: 'travel'
	},
	{
		label: 'Warm Up',
		value: 'warm_up'
	},
];

export const assignmentStatus = [
	{
		value: 'not_started',
		label: "Not Started"
	},
	{
		value: 'in_progress',
		label: "In Progress"
	},
	{
		value: 'completed',
		label: "Completed"
	},
];

export const STUDY_SET_SKILLS = {
	SPEAKING: 'speaking',
	LISTENING: 'listening',
	READING: 'reading',
	WRITING: 'writing',
};
